import { FILTER_OPTION_TYPE } from "Common/Constants";
import { isFilterValueChecked } from "Common/Functions";
import type { IDatePresetRangeFilterValue, IDrawerFilters, IFilterOption } from "Common/Interfaces";

const DATE_TIME_FILTER_ID = -1;

interface IGetFilterState {
  filters: IDrawerFilters | undefined;
  filterValues: Record<string, string | undefined>;
  datePreset: IDatePresetRangeFilterValue;
}

export const getFilterState = (props: IGetFilterState): IFilterOption[] => {
  const { filters, filterValues, datePreset } = props;

  const checkboxFilters: IFilterOption[] = (filters ?? []).map((filter) => ({
    id: filter.id,
    label: filter.label ?? "",
    type: FILTER_OPTION_TYPE.CHECKBOX,
    hasSearch: true,
    checkboxValues: (filter.options ?? []).map((opt) => ({
      value: (opt.id ?? opt.value)?.toString() ?? "",
      label: opt.displayName ?? "",
      isChecked: isFilterValueChecked(
        (opt.id ?? opt.value)?.toString() ?? "",
        filter.queryParameter ? filterValues[filter.queryParameter] : undefined,
      ),
    })),
  }));

  return [
    ...checkboxFilters,
    {
      id: DATE_TIME_FILTER_ID,
      label: "Date & Time",
      type: FILTER_OPTION_TYPE.DATE_PRESET_RANGE,
      datePresetRangeValues: datePreset,
    },
  ];
};
